import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('MEET_USERS').plugin(axiosPlugin, {template: "array"});

let fetchMeetUsersAction = redux.fetchActionGet();

export const fetchMeetUsers = (query) => fetchMeetUsersAction(`/meets/users?${queryString.stringify(query)}`);

export const resetMeetUsers = () => redux.actions.reset();

export const meetUsers = redux.reducer();